import React, { useEffect, useRef, useState } from "react";

import "./Portfolio.css";
// import img1 from "../assets/images/projects/1725.jpg"
import img1 from "../Portfolio/images/1725.jpg";
import img2 from "../Portfolio/images/Datingapp.jpg";
import img3 from "../Portfolio/images/astrology.jpg";
// import img4 from '../Portfolio/images/matir-app.jpg'
// import img5 from '../Portfolio/images/Socialmedia.jpg'
import img6 from "../Portfolio/images/lms2.jpg";
import img7 from "../Portfolio/images/fooddelivery.jpg";
import img8 from "../Portfolio/images/schoolmanagment app.jpg";
import img9 from "../Portfolio/images/clinicmanagement.jpg";
// import img10 from '../Portfolio/images/job portal app.jpg'
// import img11 from '../Portfolio/images/urban.jpg'
// import img12 from '../Portfolio/images/MLM.jpg'
import img13 from "../Portfolio/images/erpsoftwares.jpg";
// import img14 from '../Portfolio/images/recharge portal app.jpg'
import img15 from "../Portfolio/images/mlmsoftware.jpg";
import img16 from "../Portfolio/images/quizsystem.jpg";
import img17 from "../Portfolio/images/crmsoftware2.jpg";
import img18 from "../Portfolio/images/hrmsoftware2.png";
import img19 from "../Portfolio/images/hrmssoftware3.jpeg";
import img20 from "../Portfolio/images/accountingsoft.jpg";
import img21 from "../Portfolio/images/possoftware2.png";
import img22 from "../Portfolio/images/employeetracking2.jpg";
import img23 from "../Portfolio/images/inventorymanagementsystem.jpeg";
import img24 from "../Portfolio/images/warehousemanagementsystem.jpg";
// import img25 from "../Portfolio/images/university.jpg"
import img26 from "../Portfolio/images/lms2.jpg";
import img27 from "../Portfolio/images/coaching_big.png";
import img28 from "../Portfolio/images/librarymanagement.jpeg";
import img29 from "../Portfolio/images/newsportal.jpg";
import img30 from "../Portfolio/images/blogingwebsite.jpg";
import img31 from "../Portfolio/images/projectmanagement.jpg";
import img32 from "../Portfolio/images/taskmanagement.png";
import img33 from "../Portfolio/images/onlinestreaming.jpg";
import img34 from "../Portfolio/images/audiopodcast.jpeg";
import img35 from "../Portfolio/images/ebooksoftware.jpg";
import img36 from "../Portfolio/images/hospitalmanagement.jpg";
import img37 from "../Portfolio/images/labmanagement.avif";
import img38 from "../Portfolio/images/doctorappointment.jpg";
import img39 from "../Portfolio/images/pharmacymanagement.jpg";
import img40 from "../Portfolio/images/prod/ac.jpeg";
import img41 from "../Portfolio/images/prod/advocateManagement.jpg";
import img42 from "../Portfolio/images/prod/Affilate Managment System.jpg";
import img43 from "../Portfolio/images/prod/AlgoTradingApp.jpg";
import img44 from "../Portfolio/images/prod/bus booking app.jpg";
import img45 from "../Portfolio/images/prod/cab booking app.jpg";
import img46 from "../Portfolio/images/prod/cattle.png";
import img47 from "../Portfolio/images/prod/courierSystem.jpg";
import img48 from "../Portfolio/images/prod/crowdfunding.jpg";
import img49 from "../Portfolio/images/prod/CryptoTradingApp.jpg";
import img50 from "../Portfolio/images/prod/DairyFarmManager.jpg";
import img51 from "../Portfolio/images/prod/EVchargingapp.png";
import img52 from "../Portfolio/images/prod/eventManagement.jpg";
import img53 from "../Portfolio/images/prod/FlightBooking.jpg";
import img54 from "../Portfolio/images/prod/GarageWorkshopManagementSystem.jpg";
import img55 from "../Portfolio/images/prod/grocry app.jpg";
import img56 from "../Portfolio/images/prod/gym app.jpg";
import img57 from "../Portfolio/images/prod/hotel managment app.jpg";
import img58 from "../Portfolio/images/prod/LivestockManagement.jpg";
import img59 from "../Portfolio/images/prod/loan managment app.jpg";
import img60 from "../Portfolio/images/prod/looder booking app.jpg";
import img61 from "../Portfolio/images/prod/Logistic System.jpg";
import img62 from "../Portfolio/images/prod/MetaTrader_app.jpg";
import img63 from "../Portfolio/images/prod/movie app.png";
import img64 from "../Portfolio/images/prod/NGO Management.jpg";
import img65 from "../Portfolio/images/prod/property_dribbble.png";
import img66 from "../Portfolio/images/prod/pg app.jpg";
import img67 from "../Portfolio/images/prod/propertylist.jpg";
import img68 from "../Portfolio/images/prod/property_dribbble.png";
import img69 from "../Portfolio/images/prod/RealStateSoftware.jpg";
import img70 from "../Portfolio/images/prod/ride sharing app.jpg";
import img71 from "../Portfolio/images/prod/saloonManagement.png";
import img72 from "../Portfolio/images/prod/spaManagement.jpg";
import img73 from "../Portfolio/images/prod/sports.png";
import img74 from "../Portfolio/images/prod/tiffin.jpg";
import img75 from "../Portfolio/images/prod/trading app.png";
import img76 from "../Portfolio/images/prod/TravelBookingApp.jpg";
import img77 from "../Portfolio/images/prod/VehicleManagement.png";
import img78 from "../Portfolio/images/prod/VehicleTrackingApp.jpg";
import img79 from "../Portfolio/images/blockchain/blockcahindevelopment.jpg";
import img80 from "../Portfolio/images/blockchain/launchpad.webp";
import img81 from "../Portfolio/images/blockchain/wallet.png";
import img82 from "../Portfolio/images/blockchain/token.jpeg";
import img83 from "../Portfolio/images/blockchain/defi.png";
import img84 from "../Portfolio/images/blockchain/nft.jpeg";
import img85 from "../Portfolio/images/blockchain/dex.png";
import img86 from "../Portfolio/images/games/final (11).jpg";
import img87 from "../Portfolio/images/games/final (14).jpg";
import img88 from "../Portfolio/images/games/final (3).jpg";
import img89 from "../Portfolio/images/games/final (16).jpg";
import img90 from "../Portfolio/images/games/final (6).jpg";
import img91 from "../Portfolio/images/games/final (15).jpg";
import img92 from "../Portfolio/images/games/final.jpg";
import img93 from "../Portfolio/images/games/final (12).jpg";
import img94 from "../Portfolio/images/games/final (10).jpg";
import img95 from "../Portfolio/images/games/final (2).jpg";
import img96 from "../Portfolio/images/games/final (13).jpg";
import img97 from "../Portfolio/images/games/final (8).jpg";
import img98 from "../Portfolio/images/metaverse/eventplateform.jpg";
import img99 from "../Portfolio/images/metaverse/launchpad.jpeg";
import img100 from "../Portfolio/images/metaverse/metaversedevelop.png";
import img101 from "../Portfolio/images/metaverse/nftmarketplace.png";
import img102 from "../Portfolio/images/metaverse/realestate.jpeg";
import img103 from "../Portfolio/images/metaverse/socialmedia.jpg";
import img104 from "../Portfolio/images/metaverse/virtualland.jpg";
import img105 from "../Portfolio/images/metaverse/virtualshowroom.jpg";
import img106 from "../Portfolio/images/prod/payment.jpg";
import img107 from "../Portfolio/images/prod/urban.jpg";
import img108 from "../Portfolio/images/prod/restaurant.jpg";
import img109 from "../Portfolio/images/blockchain/smartcontarct.jpeg";
import img110 from "../Portfolio/images/blockchain/supplychain.jpg";
// import img112 from "../assets/images/games/roullete.jpg"
import img113 from "../Portfolio/images/games/final (7).jpg";
import img114 from "../Portfolio/images/games/final (5).jpg";
// import img115 from "../assets/images/games/final (8).jpg"
import img116 from "../Portfolio/images/games/final (18).jpg";
import img117 from "../Portfolio/images/games/final (17).jpg";
import img118 from "../Portfolio/images/games/final (9).jpg";
import img119 from "../Portfolio/images/games/final (4).jpg";
import img120 from "../Portfolio/images/games/final (20).jpg";

// import imgage from "../assets/images/logo/metablock-logos-main.png"
import brand1 from "../Portfolio/images/img/brand1.png";
import brand2 from "../Portfolio/images/img/brand2.png";
import brand3 from "../Portfolio/images/img/brand3.png";
import brand4 from "../Portfolio/images/img/brand4.png";
import brand5 from "../Portfolio/images/img/brand5.webp";
import brand6 from "../Portfolio/images/img/brand6.jpg";
import brand7 from "../Portfolio/images/img/brand7.png";
import brand8 from "../Portfolio/images/img/brand8.png";
import brand9 from "../Portfolio/images/img/brand9.jpg";
import brand10 from "../Portfolio/images/img/brand10.png";
import brand11 from "../Portfolio/images/img/brand11.png";
import brand12 from "../Portfolio/images/img/brand12.png";
// import video2 from "../Portfolio/images/img/video1.mp4";
// import imagess from "../Portfolio/images/img/new-metablock-scanner2.jpg";
import {
  FaHome,
  FaEnvelope,
  FaFacebookF,
  FaLinkedin,
  FaWhatsapp,
  FaSkype,
} from "react-icons/fa";
import {
  FiFacebook,
  FiInstagram,
  FiLinkedin,
  FiPhoneCall,
  FiMessageCircle,
  FiMessageSquare,
} from "react-icons/fi";
import { IoLocationOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { FaVideo } from "react-icons/fa";

import Timer from "../Portfolio/Timer";
import { Box } from "@mui/material";
import { FaArrowRightLong } from "react-icons/fa6";
// import { sendQuery } from '../Portfolio/userSlice'
// import { useDispatch } from 'react-redux'

import "./Portfolio.css";

const Portfolio = () => {
  const handleLocationClick = () => {};

  const [name, setName] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [softwareName, setSoftwareName] = useState("");
  const [description, setDescription] = useState("");

  const [showContactForm, setShowContactForm] = useState(false);
  // const dispatch = useDispatch()
  // const handleSubmitQuery = (e) => {
  //   e.preventDefault();
  //   dispatch(sendQuery({ name, contactNo, softwareName, description })).then(() => { setShowContactForm(false); setShowSuccess(true) })
  // }

  const nameRef = useRef();
  const contactNoRef = useRef();
  const softwareRef = useRef();
  const descriptionRef = useRef();

  const handleContactFormOpen = () => {
    setShowContactForm(true);
  };

  const [showsuccces, setShowSuccess] = useState(false);

  const handleshowsuccess = () => {
    setShowSuccess(true);
  };

  const [showAdditionalButton, setShowAdditionalButton] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    const name = nameRef.current.value;
    const contactNo = contactNoRef.current.value;
    const software = softwareRef.current.value;
    const description = descriptionRef.current.value;

    // Print the form data to the console
    console.log({
      name,
      contactNo,
      software,
      description,
    });

    setShowContactForm(false);
  };

  const navigate = useNavigate();

  const newportfolio = [
    {
      id: 1,
      category: ["SoftWare"],
      title: "E-Commerce Solution",
      image: img1,
      subtitle: "Build Your Online Empire Like Amazon and Flipkart !",
    },

    {
      id: 7,
      category: ["Application"],
      title: "Food Delivery App",
      image: img7,
      subtitle: "Build Your Online Food Dynasty Like Zomato and Swiggy !",
    },
    {
      id: 2,
      category: ["Application"],
      title: "Dating App",
      image: img2,
      subtitle: "Build Your Romantic Journey like Tinder and Bumble !",
    },
    {
      id: 3,
      category: ["Application"],
      title: "Astrology App",
      image: img3,
      subtitle:
        "Create Your Own Astrology Journey like AstroTalk and AstroSage !",
    },
    {
      id: 45,
      title: "Cab Booking App",
      image: img45,
      category: [],
      subtitle: "Build Your Travel Empire like Ola and Uber ! ",
    },

    // {
    //   id: 5,
    //   category: ["SoftWare"],
    //   title: 'Social Media Portal',
    //   image: img5,
    //   subtitle: 'Build Your Social platfrom like Facebook and Instagram !'
    // },
    {
      id: 13,
      category: ["SoftWare"],
      title: "ERP Software",
      image: img13,
      subtitle: "Create Your Business Backbone with Our ERP Solution !",
    },
    // {
    //   id: 14,
    //   category: ['SoftWare'],
    //   title: 'Recharge Portal',
    //   image: img14,
    //   subtitle: 'Elevate Your Business with Our Recharge Software !'
    // },

    {
      id: 6,
      category: ["SoftWare"],
      title: "LMS Software",
      image: img6,
      subtitle: "Build Your Educational Empire Like CYPHER and TalentLMS !",
    },
    // {
    //   id: 4,
    //   category: ["SoftWare"],
    //   title: 'Matrimonial Software',
    //   image: img4,
    //   subtitle: 'Build Your Perfect Match Platform like Shaadi and Jeevansathi !'
    // },

    // {
    //   id: 11,
    //   category: ["SoftWare"],
    //   title: 'Urban Services Software',
    //   image: img11,
    //   subtitle: "Building Better Service Booking Software: Inspired by Airtasker, Shifting, Cleaning ! "

    // },
    // {
    //   id: 12,
    //   category: ["SoftWare"],
    //   title: 'MLM Software',
    //   image: img12,
    //   subtitle: 'Develop Your Own MLM Software: Empowering Entrepreneurs Everywhere !'
    // },
    {
      id: 38,
      title: "Doctor Appointment System",
      image: img38,
      category: ["Software"],
      subtitle:
        "Build Your Own Doctor Appointment Booking System like NexHealth and Open Care !",
    },

    {
      id: 16,
      title: "Quiz System",
      image: img16,
      category: ["Application"],
      subtitle:
        "Launch Your Own Quiz System, Redefining Learning Experiences like Quizlet and Quizizz !",
    },
    // {
    //   id: 10,
    //   category: ["SoftWare"],
    //   title: 'Job Portal',
    //   image: img10,
    //   subtitle: 'Create Your Own Job Portal, Shaping Career Futures like LinkedIn and Naukri.com !'

    // },

    {
      id: 52,
      title: "Event Management Software",
      image: img52,
      category: ["SoftWare"],
      subtitle:
        "Develop Your Own Event Management Software, Redefining Event Planning like Cvent, Eventbrite !",
    },

    {
      id: 67,
      title: "Property Listing Software",
      image: img67,
      category: ["SoftWare"],
      subtitle:
        "Launch Your Own Listing Software, Simplifying Real Estate Transactions Like OLX, Buildium and MLS Software !",
    },
    {
      id: 47,
      title: "Courier Management System",
      image: img47,
      category: ["SoftWare"],
      subtitle:
        "Build Your Own Courier Management Software like Onfleet and ShipStation !",
    },

    {
      id: 108,
      category: ["SoftWare"],
      title: "Restaurant Management ",
      image: img108,
      subtitle:
        "Develop Your Own Restaurant Management Software like TouchBistro and Lightspeed restaurant !",
    },

    {
      id: 9,
      category: ["SoftWare"],
      title: "Clinic Management Software",
      image: img9,
      subtitle:
        "Develop your personalized AI-driven healthcare solution, tailored to your needs and surpassing industry standards !",
    },
    {
      id: 17,
      title: "CRM , HRMS , POS Software",
      image: img17,
      category: ["SoftWare"],
      subtitle:
        "Develop Your POS: Empower Your Business with Seamless Transaction Management, Inspired by Square POS !",
    },

    {
      id: 20,
      title: "Accounting Software",
      image: img20,
      category: ["SoftWare"],
      subtitle:
        "Develop Your Own Accounting & Billing Software: Redefining Financial Management! like Xero and Freshbooks !",
    },
    {
      id: 57,
      title: "Hotel Management Software",
      image: img57,
      category: ["SoftWare"],
      subtitle:
        "Create Your Own Hotel Management Software: Transforming Guest Experiences like Hotelogix  and Cheerze Connect !",
    },
    {
      id: 76,
      title: "Travel Booking Software",
      image: img76,
      category: ["SoftWare"],
      subtitle:
        "Build Your Own Travel Booking Software: Simplifying Journey Planning like MakeMy Trip and goibibo.com !",
    },
    {
      id: 43,
      title: "Algo Trading Software",
      image: img43,
      category: ["SoftWare"],
      subtitle:
        "Craft Your Algo Trading Platform: Inspired by MetaTrader 4 (MT4) and MT5, Empowering Your Trading Journey !",
    },
    {
      id: 59,
      title: "Loan Management System",
      image: img59,
      category: ["SoftWare"],
      subtitle:
        "Launch Your Own Loan Management System: Simplifying Borrowing Processes like LoanPro and TurnKey Lender !",
    },
    {
      id: 42,
      title: "Affilate Management System",
      image: img42,
      category: ["SoftWare"],
      subtitle:
        "Build Your Own Affiliate Management Software: Optimizing Marketing Channels !",
    },
    {
      id: 74,
      title: "Tiffin Center Management",
      image: img74,
      category: ["SoftWare"],
      subtitle:
        "Design Your Tiffin Management System: Inspired by Tiffindaily and Eatatos,  Meal Services for Your Business !",
    },

    {
      id: 33,
      title: "Online Streaming App",
      image: img33,
      category: ["Application"],
      subtitle:
        "Develop Your Own Online Streaming Platform Like Netflix and Hulu !",
    },
    {
      id: 55,
      title: "Grocery Delivery App",
      image: img55,
      category: ["Application"],
      subtitle:
        "Create a Grocery Delivery Platform Like Bigbasket and FreshDirect !",
    },
    {
      id: 106,
      category: ["Application"],
      title: "Payment Application",
      image: img106,
      subtitle:
        "Build Your Own Payment Platform Like Cash App and Google Pay !",
    },
    {
      id: 26,
      title: "LMS Application",
      image: img26,
      category: ["Application"],
      subtitle: "Build Your Educational Empire Like CYPHER and TalentLMS !",
    },
    {
      id: 107,
      category: ["Application"],
      title: "Urban Services Application",
      image: img107,
      subtitle:
        "Building Better Service Booking Software: Inspired by Airtasker, Shifting, Cleaning ! ",
    },

    {
      id: 44,
      title: "Bus Booking System",
      image: img44,
      category: ["Application"],
      subtitle: "Build a Bus Booking App Like RedBus and Goibibo.com !",
    },
    {
      id: 22,
      title: "Field Employee App",
      image: img22,
      category: ["Application"],
      subtitle: "Build a Field Tracking App Like FieldPulse and Skedulo !",
    },

    {
      id: 70,
      title: "Ride Sharing App",
      image: img70,
      category: ["Application"],
      subtitle: "Build a Ride Sharing App Like  Rapido, Uber  and Lyft!",
    },
    {
      id: 60,
      title: "Lodder Booking App",
      image: img60,
      category: ["Application"],
      subtitle:
        "Develop Your Own Lodder Booking App Like Lalamove and Porter !",
    },

    {
      id: 18,
      title: "HRM Software",
      image: img18,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 23,
      title: "Inventory Software",
      image: img23,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 24,
      title: "WareHouse Software",
      image: img24,
      category: ["SoftWare"],
      subtitle: "",
    },
    // {
    //   id: 25,
    //   title: "University Management Software",
    //   image: img25,
    //   category: ["SoftWare"],
    //   subtitle: ""
    // },

    {
      id: 27,
      title: "Coaching Management Software",
      image: img27,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 28,
      title: "Library Management System",
      image: img28,
      category: ["SoftWare"],
      subtitle: "Create a Library Management System Like Koha and Evergreen !",
    },
    {
      id: 29,
      title: "News Portal Software",
      image: img29,
      category: ["SoftWare"],
      subtitle:
        "Create a News Portal Like CNN and BBC to Keep Your Audience Informed !",
    },
    {
      id: 30,
      title: "Blogging Website",
      image: img30,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 31,
      title: "Project Management System",
      image: img31,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 32,
      title: "Task Management",
      image: img32,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 8,
      category: ["SoftWare"],
      title: "School Management",
      image: img8,
      subtitle:
        "Develop a School Management Platform Like MySchool and Gradelink !",
    },
    {
      id: 34,
      title: "Audio Podcast Software",
      image: img34,
      category: ["SoftWare"],
      subtitle: "Develop Audio Podcast Software Like Spotify and Anchor !",
    },
    {
      id: 35,
      title: "E-Book Software",
      image: img35,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 36,
      title: "Hospital Management Software",
      image: img36,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 37,
      title: "Lab Management Software",
      image: img37,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 39,
      title: "Pharmacy Management",
      image: img39,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 40,
      title: "AC Repairing App",
      image: img40,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 41,
      title: "Advocate Management Software",
      image: img41,
      category: ["SoftWare"],
      subtitle: "",
    },

    // {
    //   id: 15,
    //   category: ["SoftWare"],
    //   title: 'MLM SoftWare',
    //   image: img15,
    //   subtitle: 'Develop Your Own MLM Software, Empowering Entrepreneurs Everywhere'
    // },

    {
      id: 46,
      title: "Cattle Management System",
      image: img46,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 48,
      title: "Crowdfunding Software",
      image: img48,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 49,
      title: "Crypto Trading App",
      image: img49,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 50,
      title: "Dairy Farm Management",
      image: img50,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 51,
      title: "EV Charging App",
      image: img51,
      category: ["Application"],
      subtitle: "Create an EV Charging Station App Like Blink and Greenlots !",
    },

    {
      id: 53,
      title: "Flight Booking App",
      image: img53,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 54,
      title: "Garage Workshop Software",
      image: img54,
      category: ["SoftWare"],
      subtitle:
        "Manage Your Garage Like a Pro with Software Like Shop-Ware and Tekmetric !",
    },

    {
      id: 56,
      title: "Gym Management System",
      image: img56,
      category: ["SoftWare"],
      subtitle:
        "Build Your Own Gym Management Software Like Zenoti and ClubReady !",
    },

    {
      id: 58,
      title: "LiveStock Management System",
      image: img58,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 61,
      title: "Logistic Management Software",
      image: img61,
      category: ["SoftWare"],
      subtitle: " ",
    },
    {
      id: 62,
      title: "Metatrade Trading App",
      image: img62,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 63,
      title: "Movie Ticket Booking",
      image: img63,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 64,
      title: "NGO Management Software",
      image: img64,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 65,
      title: "Property Management",
      image: img65,
      category: ["SoftWare"],
      subtitle:
        "Build Property Management Software Like MagicBricks and Zillow Rental Manager !",
    },
    {
      id: 66,
      title: "PG Management Software",
      image: img66,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 69,
      title: "Real EState Software",
      image: img69,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 71,
      title: "Saloon Management App",
      image: img71,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 72,
      title: "Spa Management System",
      image: img72,
      category: ["SoftWare"],
      subtitle: "SoftWare",
    },
    {
      id: 73,
      title: "Sport Management Software",
      image: img73,
      category: ["SoftWare"],
      subtitle:
        "Develop Your Own Sports Management Software Like CoachUp and Active Network !",
    },

    {
      id: 75,
      title: "Trading App",
      image: img75,
      category: ["Application"],
      subtitle: "",
    },

    {
      id: 77,
      title: "Vehicle Management System",
      image: img77,
      category: ["SoftWare"],
      subtitle: "Develop a Vehicle Management System Like Fleetio and Azuga !",
    },
    {
      id: 78,
      title: "Vehicle Tracking Software",
      image: img78,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 79,
      category: ["Blockchain"],
      title: "Blockchain Development",
      image: img79,
      subtitle: "",
    },
    {
      id: 82,
      category: ["Blockchain"],
      title: "Token Development",
      image: img82,
      subtitle: "",
    },
    {
      id: 85,
      category: ["Blockchain"],
      title: "Dex Development",
      image: img85,
      subtitle: "",
    },
    {
      id: 80,
      category: ["Blockchain"],
      title: "Decentralised MLM Software",
      image: img80,
      subtitle: "",
    },
    {
      id: 84,
      category: ["Blockchain"],
      title: "NFT Marketplace Development",
      image: img84,
      subtitle: "",
    },
    {
      id: 109,
      category: ["Blockchain"],
      title: "Smart Contract Development",
      image: img109,
      subtitle: "",
    },
    {
      id: 81,
      category: ["Blockchain"],
      title: "Wallet Development",
      image: img81,
      subtitle: "",
    },

    {
      id: 83,
      category: ["Blockchain"],
      title: "Defi Development",
      image: img83,
      subtitle: "",
    },

    {
      id: 110,
      category: ["Blockchain"],
      title: "Supplychain Management",
      image: img110,
      subtitle: "",
    },

    {
      id: 92,
      category: ["Games"],
      title: "Ludo Game development",
      image: img92,
      subtitle: "",
    },
    // {
    //   id: 92,
    //   category: ["Games"],
    //   title: 'Aviator Game Development',
    //   image: img92,
    //   subtitle: ''
    // },
    // {
    //   id: 95,
    //   category: ["Games"],
    //   title: 'Lottery Game Development',
    //   image: img95,
    //   subtitle: ''
    // },
    // {
    //   id: 88,
    //   category: ["Games"],
    //   title: 'Wingo or Colour Prediction Game',
    //   image: img88,
    //   subtitle: ''
    // },
    // {
    //   id: 90,
    //   category: ["Games"],
    //   title: 'All in one Casino Game Development',
    //   image: img90,
    //   subtitle: ''
    // },
    // {
    //   id: 94,
    //   category: ["Games"],
    //   title: 'Tiranga Game Development',
    //   image: img94,
    //   subtitle: ''
    // },

    // {
    //   id: 86,
    //   category: ["Games"],
    //   title: 'BDG Game Devlopment',
    //   image: img86,
    //   subtitle: ''
    // },

    // {
    //   id: 96,
    //   category: ["Games"],
    //   title: 'Goa Game Development',
    //   image: img96,
    //   subtitle: ''
    // },

    // {
    //   id: 93,
    //   category: ["Games"],
    //   title: '91 Club Game Development',
    //   image: img93,
    //   subtitle: ''
    // },
    {
      id: 97,
      category: ["Games"],
      title: "Ludo Game Development",
      image: img97,
      subtitle: "",
    },

    {
      id: 87,
      category: ["Games"],
      title: "Teen Patti Game Development",
      image: img87,
      subtitle: "",
    },
    {
      id: 89,
      category: ["Games"],
      title: "Fantasy Cricket Game like Dream11",
      image: img89,
      subtitle: "",
    },
    // {
    //   id: 118,
    //   category: ["Games"],
    //   title: 'Dragon Tiger Game Development',
    //   image: img118,
    //   subtitle: ''
    // },
    {
      id: 119,
      category: ["Games"],
      title: "Rummy Game Development ",
      image: img119,
      subtitle: "",
    },
    {
      id: 120,
      category: ["Games"],
      title: "Ludo Game Development ( Room Code )",
      image: img120,
      subtitle: "",
    },

    {
      id: 91,
      category: ["Games"],
      title: "Tournament Development",
      image: img91,
      subtitle: "",
    },
    // {
    //   id: 113,
    //   category: ["Games"],
    //   title: 'Fastwin Game Development',
    //   image: img113,
    //   subtitle: ''
    // },
    // {
    //   id: 114,
    //   category: ["Games"],
    //   title: 'Roulette Game Development',
    //   image: img114,
    //   subtitle: ''
    // },

    {
      id: 116,
      category: ["Games"],
      title: "Skill Game Development",
      image: img116,
      subtitle: "",
    },
    {
      id: 117,
      category: ["Games"],
      title: "Metaverse Game Development",
      image: img117,
      subtitle: "",
    },
    {
      id: 100,
      category: ["Metaverse"],
      title: "Metaverse Development",
      image: img100,
      subtitle: "",
    },
    {
      id: 105,
      category: ["Metaverse"],
      title: "Metaverse Virtual Showroom",
      image: img105,
      subtitle: "",
    },
    {
      id: 104,
      category: ["Metaverse"],
      title: "Virtual Academic Classes",
      image: img104,
      subtitle: "",
    },

    {
      id: 101,
      category: ["Metaverse"],
      title: "Metaverse Avatar Development ",
      image: img101,
      subtitle: "",
    },
    {
      id: 98,
      category: ["Metaverse"],
      title: "Metaverse Event Plateform",
      image: img98,
      subtitle: "",
    },
    {
      id: 103,
      category: ["Metaverse"],
      title: "Social Media Platform",
      image: img103,
      subtitle: "",
    },
    {
      id: 102,
      category: ["Metaverse"],
      title: "Metaverse Real State",
      image: img102,
      subtitle: "",
    },
    {
      id: 99,
      category: ["Metaverse"],
      title: "Launchpad Development",
      image: img99,
      subtitle: "",
    },
  ];

  const portfolioItems = [
    // {
    //   id: 5,
    //   category: ["SoftWare"],
    //   title: 'Social Media Portal',
    //   image: img5,
    //   subtitle: 'Build Your Social platfrom like Facebook and Instagram !'
    // },
    {
      id: 1,
      category: ["SoftWare"],
      title: "E-Commerce Solution",
      image: img1,
      subtitle: "Build Your Online Empire Like Amazon and Flipkart !",
    },

    {
      id: 6,
      category: ["SoftWare"],
      title: "LMS Software",
      image: img6,
      subtitle: "Build Your Educational Empire Like CYPHER and TalentLMS !",
    },

    // {
    //   id: 12,
    //   category: ["SoftWare"],
    //   title: 'MLM Software',
    //   image: img12,
    //   subtitle: 'Develop Your Own MLM Software: Empowering Entrepreneurs Everywhere !'
    // },

    // {
    //   id: 14,
    //   category: ['SoftWare'],
    //   title: 'Recharge Portal',
    //   image: img14,
    //   subtitle: 'Elevate Your Business with Our Recharge Software !'
    // },
    // {
    //   id: 11,
    //   category: ["SoftWare"],
    //   title: 'Urban Services Software',
    //   image: img11,
    //   subtitle: "Building Better Service Booking Software: Inspired by Airtasker, Shifting, Cleaning ! "

    // },
    {
      id: 108,
      category: ["SoftWare"],
      title: "Restaurant Management  ",
      image: img108,
      subtitle:
        "Develop Your Own Restaurant Management Software like TouchBistro and Lightspeed restaurant !",
    },

    // {
    //   id: 10,
    //   category: ["SoftWare"],
    //   title: 'Job Portal',
    //   image: img10,
    //   subtitle: 'Create Your Own Job Portal, Shaping Career Futures like LinkedIn and Naukri.com !'

    // },
    {
      id: 9,
      category: ["SoftWare"],
      title: "Clinic Management Software",
      image: img9,
      subtitle:
        "Build Your Own Clinic Management Software  like QMarksoft Clinic Management and AdvancedMD !",
    },
    {
      id: 17,
      title: "CRM , HRMS , POS Software",
      image: img17,
      category: ["SoftWare"],
      subtitle:
        "Develop Your POS: Empower Your Business with Seamless Transaction Management, Inspired by Square POS !",
    },
    {
      id: 76,
      title: "Travel Booking Software",
      image: img76,
      category: ["SoftWare"],
      subtitle:
        "Build Your Own Travel Booking Software: Simplifying Journey Planning like MakeMy Trip and goibibo.com !",
    },

    {
      id: 20,
      title: "Accounting  Software",
      image: img20,
      category: ["SoftWare"],
      subtitle:
        "Develop Your Own Accounting & Billing Software: Redefining Financial Management! like Xero and Freshbooks !",
    },

    {
      id: 42,
      title: "Affilate Management System",
      image: img42,
      category: ["SoftWare"],
      subtitle:
        "Build Your Own Affiliate Management Software: Optimizing Marketing Channels !",
    },

    {
      id: 13,
      category: ["SoftWare"],
      title: "ERP Software",
      image: img13,
      subtitle: "Create Your Business Backbone with Our ERP Solution !",
    },

    {
      id: 43,
      title: "Algo Trading Software",
      image: img43,
      category: ["SoftWare"],
      subtitle:
        "Craft Your Algo Trading Platform: Inspired by MetaTrader 4 (MT4) and MT5, Empowering Your Trading Journey !",
    },
    {
      id: 59,
      title: "Loan Management System",
      image: img59,
      category: ["SoftWare"],
      subtitle:
        "Launch Your Own Loan Management System: Simplifying Borrowing Processes like LoanPro and TurnKey Lender !",
    },
    {
      id: 57,
      title: "Hotel Management Software",
      image: img57,
      category: ["SoftWare"],
      subtitle:
        "Create Your Own Hotel Management Software: Transforming Guest Experiences like Hotelogix  and Cheerze Connect !",
    },

    {
      id: 74,
      title: "Tiffin Center Management",
      image: img74,
      category: ["SoftWare"],
      subtitle:
        "Design Your Tiffin Management System: Inspired by Tiffindaily and Eatatos,  Meal Services for Your Business !",
    },

    {
      id: 7,
      category: ["Application"],
      title: "Food Delivery App",
      image: img7,
      subtitle: "Build Your Online Food Dynasty Like Zomato and Swiggy !",
    },
    {
      id: 45,
      title: "Cab Booking App",
      image: img45,
      category: ["Application"],
      subtitle: "Build Your Travel Empire like Ola and Uber ! ",
    },
    {
      id: 3,
      category: ["Application"],
      title: "Astrology App",
      image: img3,
      subtitle:
        "Create Your Own Astrology Journey like AstroTalk and AstroSage !",
    },
    {
      id: 2,
      category: ["Application"],
      title: "Dating App",
      image: img2,
      subtitle: "Build Your Romantic Journey like Tinder and Bumble !",
    },
    // {
    //   id: 5,
    //   category: ["Application"],
    //   title: 'Social Media Application',
    //   image: img5,
    //   subtitle: 'Build Your Social platfrom like Facebook and Instagram !'
    // },
    {
      id: 33,
      title: "Online Streaming App",
      image: img33,
      category: ["Application"],
      subtitle:
        "Develop Your Own Online Streaming Platform Like Netflix and Hulu !",
    },
    {
      id: 55,
      title: "Grocery Delivery App",
      image: img55,
      category: ["Application"],
      subtitle:
        "Create a Grocery Delivery Platform Like Bigbasket and FreshDirect !",
    },
    {
      id: 106,
      category: ["Application"],
      title: "Payment Application",
      image: img106,
      subtitle:
        "Build Your Own Payment Platform Like Cash App and Google Pay !",
    },
    {
      id: 26,
      title: "LMS Application",
      image: img26,
      category: ["Application"],
      subtitle: "Build Your Educational Empire Like CYPHER and TalentLMS !",
    },
    {
      id: 107,
      category: ["Application"],
      title: "Urban Services Application",
      image: img107,
      subtitle:
        "Building Better Service Booking Software: Inspired by Airtasker, Shifting, Cleaning ! ",
    },

    {
      id: 44,
      title: "Bus Booking System",
      image: img44,
      category: ["Application"],
      subtitle: "Build a Bus Booking App Like RedBus and Goibibo.com !",
    },
    {
      id: 22,
      title: "Field Employee App",
      image: img22,
      category: ["Application"],
      subtitle: "Build a Field Tracking App Like FieldPulse and Skedulo !",
    },
    {
      id: 16,
      title: "Quiz System",
      image: img16,
      category: ["Application"],
      subtitle:
        "Launch Your Own Quiz System, Redefining Learning Experiences like Quizlet and Quizizz !",
    },

    {
      id: 70,
      title: "Ride Sharing App",
      image: img70,
      category: ["Application"],
      subtitle: "Build a Ride Sharing App Like Rapido, Uber and Lyft !",
    },
    {
      id: 60,
      title: "Lodder Booking App",
      image: img60,
      category: ["Application"],
      subtitle:
        "Develop Your Own Lodder Booking App Like Lalamove and Porter !",
    },

    // {
    //   id: 4,
    //   category: ["SoftWare"],
    //   title: 'Matrimonial Software',
    //   image: img4,
    //   subtitle: 'Build Your Perfect Match Platform like Shaadi and Jeevansathi !'
    // },

    {
      id: 38,
      title: "Doctor Appointment System",
      image: img38,
      category: ["Software"],
      subtitle:
        "Build Your Own Doctor Appointment Booking System like NexHealth and Open Care !",
    },

    {
      id: 52,
      title: "Event Management Software",
      image: img52,
      category: ["SoftWare"],
      subtitle:
        "Develop Your Own Event Management Software, Redefining Event Planning like Cvent, Eventbrite !",
    },

    {
      id: 67,
      title: "Property Listing Software",
      image: img67,
      category: ["SoftWare"],
      subtitle:
        "Launch Your Own Listing Software, Simplifying Real Estate Transactions Like OLX, Buildium and MLS Software !",
    },
    {
      id: 47,
      title: "Courier Management System",
      image: img47,
      category: ["SoftWare"],
      subtitle:
        "Build Your Own Courier Management Software like Onfleet and ShipStation !",
    },

    {
      id: 18,
      title: "HRM Software",
      image: img18,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 23,
      title: "Inventory Software",
      image: img23,
      category: ["SoftWare"],
      subtitle: " ",
    },
    {
      id: 24,
      title: "WareHouse Software",
      image: img24,
      category: ["SoftWare"],
      subtitle: "",
    },
    // {
    //   id: 25,
    //   title: "University Management Software",
    //   image: img25,
    //   category: ["SoftWare"],
    //   subtitle: ""
    // },

    {
      id: 27,
      title: "Coaching Management Software",
      image: img27,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 28,
      title: "Library Management System",
      image: img28,
      category: ["SoftWare"],
      subtitle: "Create a Library Management System Like Koha and Evergreen !",
    },
    {
      id: 29,
      title: "News Portal Software",
      image: img29,
      category: ["SoftWare"],
      subtitle:
        "Create a News Portal Like CNN and BBC to Keep Your Audience Informed !",
    },
    {
      id: 30,
      title: "Blogging Website",
      image: img30,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 31,
      title: "Project Management System",
      image: img31,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 32,
      title: "Task Management",
      image: img32,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 8,
      category: ["SoftWare"],
      title: "School Management",
      image: img8,
      subtitle:
        "Develop a School Management Platform Like MySchool and Gradelink !",
    },
    {
      id: 34,
      title: "Audio Podcast Software",
      image: img34,
      category: ["SoftWare"],
      subtitle: "Develop Audio Podcast Software Like Spotify and Anchor !",
    },
    {
      id: 35,
      title: "E-Book Software",
      image: img35,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 36,
      title: "Hospital Management Software",
      image: img36,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 37,
      title: "Lab Management",
      image: img37,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 39,
      title: "Pharmacy Management",
      image: img39,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 40,
      title: "AC Repairing",
      image: img40,
      category: [],
      subtitle: "",
    },
    {
      id: 41,
      title: "Advocate Management Software",
      image: img41,
      category: ["SoftWare"],
      subtitle: "",
    },

    // {
    //   id: 15,
    //   category: ["SoftWare"],
    //   title: 'MLM SoftWare',
    //   image: img15,
    //   subtitle: 'Develop Your Own MLM Software, Empowering Entrepreneurs Everywhere'
    // },

    {
      id: 46,
      title: "Cattle Management System",
      image: img46,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 48,
      title: "Crowdfunding Software",
      image: img48,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 49,
      title: "Crypto Trading App",
      image: img49,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 50,
      title: "Dairy Farm Management",
      image: img50,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 51,
      title: "EV Charging App",
      image: img51,
      category: ["Application"],
      subtitle: "Create an EV Charging Station App Like Blink and Greenlots !",
    },

    {
      id: 53,
      title: "Flight Booking App",
      image: img53,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 54,
      title: "Garage Workshop Software",
      image: img54,
      category: ["SoftWare"],
      subtitle:
        "Manage Your Garage Like a Pro with Software Like Shop-Ware and Tekmetric !",
    },

    {
      id: 56,
      title: "Gym Management System",
      image: img56,
      category: ["SoftWare"],
      subtitle:
        "Build Your Own Gym Management Software Like Zenoti and ClubReady !",
    },

    {
      id: 58,
      title: "LiveStock Management System",
      image: img58,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 61,
      title: "Logistic Management Software",
      image: img61,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 62,
      title: "Metatrade Trading App",
      image: img62,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 63,
      title: "Movie Ticket Booking",
      image: img63,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 64,
      title: "NGO Management Software",
      image: img64,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 65,
      title: "Property Management",
      image: img65,
      category: ["SoftWare"],
      subtitle:
        "Build Property Management Software Like MagicBricks and Zillow Rental Manager !",
    },
    {
      id: 66,
      title: "PG Management Software",
      image: img66,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 69,
      title: "Real EState Software",
      image: img69,
      category: ["SoftWare"],
      subtitle: "",
    },

    {
      id: 71,
      title: "Saloon Management App",
      image: img71,
      category: ["Application"],
      subtitle: "",
    },
    {
      id: 72,
      title: "Spa Management System",
      image: img72,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 73,
      title: "Sport Management Software",
      image: img73,
      category: ["SoftWare"],
      subtitle:
        "Develop Your Own Sports Management Software Like CoachUp and Active Network !",
    },

    {
      id: 75,
      title: "Trading App",
      image: img75,
      category: ["Application"],
      subtitle: "",
    },

    {
      id: 77,
      title: "Vehicle Management System",
      image: img77,
      category: ["SoftWare"],
      subtitle: "Develop a Vehicle Management System Like Fleetio and Azuga.",
    },
    {
      id: 78,
      title: "Vehicle Tracking Software",
      image: img78,
      category: ["SoftWare"],
      subtitle: "",
    },
    {
      id: 79,
      category: ["Blockchain"],
      title: "Blockchain Development",
      image: img79,
      subtitle: "",
    },
    {
      id: 82,
      category: ["Blockchain"],
      title: "Token Development",
      image: img82,
      subtitle: "",
    },
    {
      id: 85,
      category: ["Blockchain"],
      title: "Dex Development",
      image: img85,
      subtitle: "",
    },
    {
      id: 80,
      category: ["Blockchain"],
      title: "Decentralised MLM Software",
      image: img80,
      subtitle: "",
    },
    {
      id: 84,
      category: ["Blockchain"],
      title: "NFT Marketplace Development",
      image: img84,
      subtitle: "",
    },
    {
      id: 109,
      category: ["Blockchain"],
      title: "Smart Contract Development",
      image: img109,
      subtitle: "",
    },
    {
      id: 81,
      category: ["Blockchain"],
      title: "Wallet Development",
      image: img81,
      subtitle: "",
    },

    {
      id: 83,
      category: ["Blockchain"],
      title: "Defi Development",
      image: img83,
      subtitle: "",
    },

    {
      id: 110,
      category: ["Blockchain"],
      title: "Supplychain Management",
      image: img110,
      subtitle: "",
    },

    // {
    //   id: 92,
    //   category: ["Games"],
    //   title: "Aviator Game Development",
    //   image: img92,
    //   subtitle: "",
    // },
    // {
    //   id: 95,
    //   category: ["Games"],
    //   title: "Lottery Game Development",
    //   image: img95,
    //   subtitle: "",
    // },
    // {
    //   id: 88,
    //   category: ["Games"],
    //   title: "Wingo or Colour Prediction Game",
    //   image: img88,
    //   subtitle: "",
    // },
    // {
    //   id: 90,
    //   category: ["Games"],
    //   title: "All in one Casino Game Development",
    //   image: img90,
    //   subtitle: "",
    // },
    // {
    //   id: 94,
    //   category: ["Games"],
    //   title: "Tiranga Game Development",
    //   image: img94,
    //   subtitle: "",
    // },

    // {
    //   id: 86,
    //   category: ["Games"],
    //   title: "BDG Game Devlopment",
    //   image: img86,
    //   subtitle: "",
    // },

    // {
    //   id: 96,
    //   category: ["Games"],
    //   title: "Goa Game Development",
    //   image: img96,
    //   subtitle: "",
    // },

    // {
    //   id: 93,
    //   category: ["Games"],
    //   title: "91 Club Game Development",
    //   image: img93,
    //   subtitle: "",
    // },
    {
      id: 97,
      category: ["Games"],
      title: "Ludo Game Development",
      image: img97,
      subtitle: "",
    },

    {
      id: 87,
      category: ["Games"],
      title: "Teen Patti Game Development",
      image: img87,
      subtitle: "",
    },
    {
      id: 89,
      category: ["Games"],
      title: "Fantasy Cricket Game like Dream11",
      image: img89,
      subtitle: "",
    },
    // {
    //   id: 118,
    //   category: ["Games"],
    //   title: "Dragon Tiger Game Development",
    //   image: img118,
    //   subtitle: "",
    // },
    {
      id: 119,
      category: ["Games"],
      title: "Rummy Game Development ",
      image: img119,
      subtitle: "",
    },
    {
      id: 120,
      category: ["Games"],
      title: "Ludo Game Development ( Room Code )",
      image: img120,
      subtitle: "",
    },

    {
      id: 91,
      category: ["Games"],
      title: "Tournament Development",
      image: img91,
      subtitle: "",
    },
    // {
    //   id: 113,
    //   category: ["Games"],
    //   title: "Fastwin Game Development",
    //   image: img113,
    //   subtitle: "",
    // },
    // {
    //   id: 114,
    //   category: ["Games"],
    //   title: "Roulette Game Development",
    //   image: img114,
    //   subtitle: "",
    // },

    {
      id: 116,
      category: ["Games"],
      title: "Skill Game Development",
      image: img116,
      subtitle: "",
    },
    {
      id: 117,
      category: ["Games"],
      title: "Metaverse Game Development",
      image: img117,
      subtitle: "",
    },

    {
      id: 100,
      category: ["Metaverse"],
      title: "Metaverse Development",
      image: img100,
      subtitle: "",
    },
    {
      id: 105,
      category: ["Metaverse"],
      title: "Metaverse Virtual Showroom",
      image: img105,
      subtitle: "",
    },
    {
      id: 104,
      category: ["Metaverse"],
      title: "Virtual Academic Classes",
      image: img104,
      subtitle: "",
    },

    {
      id: 101,
      category: ["Metaverse"],
      title: "Metaverse Avatar Development ",
      image: img101,
      subtitle: "",
    },
    {
      id: 98,
      category: ["Metaverse"],
      title: "Metaverse Event Plateform",
      image: img98,
      subtitle: "",
    },
    {
      id: 103,
      category: ["Metaverse"],
      title: "Social Media Platform",
      image: img103,
      subtitle: "",
    },
    {
      id: 102,
      category: ["Metaverse"],
      title: "Metaverse Real State",
      image: img102,
      subtitle: "",
    },
    {
      id: 99,
      category: ["Metaverse"],
      title: "Launchpad Development",
      image: img99,
      subtitle: "",
    },
  ];

  const brands = [
    {
      image: brand1,
    },
    {
      image: brand2,
    },
    {
      image: brand3,
    },
    {
      image: brand4,
    },
    {
      image: brand5,
    },
    {
      image: brand6,
    },
  ];

  const brands2 = [
    {
      image: brand7,
    },
    {
      image: brand8,
    },
    {
      image: brand9,
    },
    {
      image: brand10,
    },
    {
      image: brand11,
    },
    {
      image: brand12,
    },
  ];
  const [selectedCategory, setSelectedCategory] = useState("Games");
  const [displayAllItems, setDisplayAllItems] = useState(true);
  const [displayCount, setDisplayCount] = useState(18);

  const displayCounts = {
    Application: 15,
    SoftWare: 18,
    Blockchain: 9,
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setDisplayAllItems(true); // Set displayAllItems to true when changing the category
  };

  const softwareDisplayCount =
    selectedCategory in displayCounts
      ? displayCounts[selectedCategory]
      : displayCount;

  const itemIdToShowInAllCategory = [
    1, 7, 2, 3, 45, 5, 13, 14, 6, 4, 11, 38, 12, 16, 10, 52, 67, 47,
  ];

  const filteredPortfolioItems =
    selectedCategory === "All"
      ? displayAllItems
        ? newportfolio
            .filter((item) => itemIdToShowInAllCategory.includes(item.id))
            .slice(0, 18)
        : newportfolio
      : !displayAllItems
      ? portfolioItems.filter((item) =>
          item.category.includes(selectedCategory)
        )
      : portfolioItems
          .filter((item) => item.category.includes(selectedCategory))
          .slice(0, softwareDisplayCount);

  const handleViewToggle = () => {
    if (
      selectedCategory === "Blockchain" ||
      selectedCategory === "Metaverse" ||
      selectedCategory === "Games" ||
      selectedCategory === "Application"
    ) {
      setSelectedCategory("All");
    }
    setDisplayAllItems(!displayAllItems);
  };

  const [showVideoModal, setShowVideoModal] = useState(false);

  const handleKnowMoreClick = () => {
    setShowContactForm(true);
  };

  const words = [
    "E-Commerce Website",
    "Dating App",
    "Astrology App",
    "Matrimonial Software",
    "Social Media Portal",
    "LMS Software",
    "Food Delivery App",
    "School Management Software",
    "Clinic Management Software",
    "Job Portal",
    "Recharge Portal",
    "MLM Software",
    "ERP Software",
    "HRMS Software",
    "Accounting Software",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to change the word index
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);
  return (
    <div>
      <div className="main-home">
        <header className="rainbow-header header-default header-transparent header-center-align header-sticky">
          <div className="container position-relative">
            <div className="row align-items-center">
              <div className="col-lg-2 col-md-6 col-6">
                {/* <div className="header-left">
                <div className="landing-logo">
                  <a style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
                    <img src={imgage} alt="Metablock Logo" />
                  </a>
                </div>
              </div> */}
              </div>

              <div className="col-lg-2 col-md-6 col-6">
                <div className="header-right"></div>
              </div>
            </div>
          </div>
        </header>

        <div>
          <div className="rainbow-gradient-circle" />
          <div className="rainbow-gradient-circle theme-pink" />
        </div>

        <div className="rbt-separator-mid">
          <div className="container">
            <hr className="rbt-separator m-0" />
          </div>
        </div>
        {/* End Seperator Area  */}
        {/* Start Slider Area  */}
        <div
          style={{ backgroundSize: "cover" }}
          className="slider-area slider-style-1 variation-default bg_image  height-950 d-flex align-items-center bg_image--23"
          id="home"
          data-black-overlay={7}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="inner text-center mb-32">
                  <h1
                    style={{ marginTop: "40vh" }}
                    className="title display-one"
                  >
                    Build Your Software
                    <br />
                    <span className="">
                      <span className="cd-headline clip is-full-width">
                        <span className="cd-words-wrapper">
                          {words.map((word, index) => (
                            <b
                              key={index}
                              className={
                                index === currentIndex
                                  ? "is-visible theme-gradient"
                                  : "is-hidden theme-gradient"
                              }
                            >
                              {word}
                            </b>
                          ))}
                        </span>
                      </span>
                    </span>
                  </h1>
                  <p className="description">
                    Maximize Your Business's Success with Our Ready-to-Use
                    Software Solutions !
                  </p>
                  <div className="button-group mt--30">
                    <a
                      onClick={handleContactFormOpen}
                      style={{ cursor: "pointer" }}
                      className="btn-default round btn-large"
                    >
                      GET STARTED NOW!
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Start Service-5 Area  */}
        {/* Start Seperator Area  */}
        <div className="rbt-separator-mid">
          <div className="container">
            <hr className="rbt-separator m-0" />
          </div>
        </div>
        {/* End Seperator Area  */}
        {/* Start Portfolio Area  */}
        <div
          className="rainbow-portfolio-area rainbow-section-gap masonary-wrapper-activation"
          id="projects"
        >
          <div className="container">
            <div className="w-100 d-flex align-items-center justify-content-center flex-column ready-use">
              <h3
                style={{ fontSize: "35px" }}
                className="display-6 pb-3 text-center pt-5 glow-text lh-1 mb-3 text-white fw-bold section-title g-text "
              >
                Our <br /> Ready-to-Use <br /> Software Solutions
              </h3>
              <p className="text-center text-white">
                We help Business grow and dominate their industries with the
                help <br />
                of the latest IT technologies and experiences.
              </p>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="rainbow-portfolio-filter filter-button-default messonry-button text-center mb--30">
                  <button
                    onClick={() => {
                      setSelectedCategory("All");
                      // setDisplayAllItems(true);
                    }}
                    className={selectedCategory === "All" ? "is-checked" : ""}
                    data-filter="*"
                  >
                    <span className="filter-text">All</span>
                  </button>
                  <button
                    onClick={() => {
                      setSelectedCategory("SoftWare");
                      setDisplayAllItems(true);
                    }}
                    className={
                      selectedCategory === "SoftWare" ? "is-checked" : ""
                    }
                    data-filter=".SoftWare"
                  >
                    <span className="filter-text">Software</span>
                  </button>
                  <button
                    onClick={() => {
                      setSelectedCategory("Application");
                      setDisplayAllItems(true);
                    }}
                    className={
                      selectedCategory === "Application" ? "is-checked" : ""
                    }
                    data-filter=".Application"
                  >
                    <span className="filter-text">Application</span>
                  </button>
                  <button
                    onClick={() => {
                      setSelectedCategory("Games");
                      setDisplayAllItems(true);
                    }}
                    className={selectedCategory === "Games" ? "is-checked" : ""}
                    data-filter=".Games"
                  >
                    <span className="filter-text">Games</span>
                  </button>
                  <button
                    onClick={() => {
                      setSelectedCategory("Blockchain");
                      setDisplayAllItems(true);
                    }}
                    className={
                      selectedCategory === "Blockchain" ? "is-checked" : ""
                    }
                    data-filter=".Blockchain"
                  >
                    <span className="filter-text">Blockchain</span>
                  </button>

                  <button
                    onClick={() => {
                      setSelectedCategory("Metaverse");
                      setDisplayAllItems(true);
                    }}
                    className={
                      selectedCategory === "Metaverse" ? "is-checked" : ""
                    }
                    data-filter=".Metaverse"
                  >
                    <span className="filter-text">Metaverse</span>
                  </button>
                </div>
                <div className="portfolio-items grid-metro3 mesonry-list">
                  <div className="resizer" />
                  {/* Render portfolio items dynamically */}
                  <div className="portfolio-row flex flex-wrap">
                    {filteredPortfolioItems.map((item, index) => (
                      <div
                        key={item.id}
                        className={`portfolio-3 ${item.category.join(" ")}`}
                      >
                        <div className="rainbow-card portfolio h-full ">
                          <div className="inner h-full block relative">
                            <div className="thumbnail ">
                              <figure className="card-image">
                                <a href="portfolio-details.html">
                                  <Link onClick={handleKnowMoreClick}>
                                    <img
                                      style={{
                                        height: "50vh",
                                        marginLeft: "30px",
                                      }}
                                      src={item.image}
                                      alt={item.title}
                                    />
                                  </Link>
                                </a>
                              </figure>
                              <a className="rainbow-overlay" />
                            </div>
                            <div className="content mt-84 w-full">
                              <h5 className="title mb-20 ">
                                <a className="heading-conatant  ml-[-320px]">
                                  {item.title}
                                </a>
                                <br />
                                {/* <span>{item.subtitle}</span> */}
                              </h5>
                              <div style={{ margin: "auto" }}>
                                <button onClick={handleKnowMoreClick}>
                                  Know More
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* Start Load More Button  */}
            <div className="row row--15">
              <div className="col-lg-12">
                <div className="rainbow-load-more text-center mt--60">
                  <a
                    href="#projects"
                    className="btn btn-default btn-large btn-icon round"
                    onClick={handleViewToggle}
                  >
                    <span>{displayAllItems ? "View More" : "View Less"}</span>
                    <span className="icon"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Portfolio Area  */}
        {/* Start Seperator Area  */}
        <div className="rbt-separator-mid">
          <div className="container">
            <hr className="rbt-separator m-0" />
          </div>
        </div>
        {/* End Seperator Area  */}
        {/* Start Brand Style-1  */}
        <div className="rainbow-brand-area rainbow-section-gap" id="clients">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="section-title text-center"
                  data-sal-duration={700}
                  data-sal-delay={100}
                >
                  <h2 className="title w-600 mb--50">
                    Brands We Have Worked With
                  </h2>
                  <p className="description b1"> </p>
                </div>
              </div>
            </div>
            <div className="brands-div flex">
              {brands.map((item, index) => (
                <div key={index}>
                  <img
                    style={{
                      width: "100px",
                      height: "80px",
                      marginLeft: "70px",
                    }}
                    src={item.image}
                    alt=""
                  />
                </div>
              ))}
            </div>

            <div style={{ marginTop: "10vh" }} className="brands-div flex">
              {brands2.map((item, index) => (
                <div key={index}>
                  <img
                    style={{
                      width: "100px",
                      height: "80px",
                      marginLeft: "70px",
                    }}
                    src={item.image}
                    alt=""
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <Modal show={showContactForm} onHide={() => setShowContactForm(false)}>
          <Modal.Body className="modal-body mt-60 ">
            <div className=" d-flex align-items-center">
              <div className="relative pb-[56.25%] h-[450px] w-full overflow-hidden rounded-lg">
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://metablock-software.metablocktechnologies.org/forms/wtl/fd876e62bfe1d7911b0e2be0ddb895fb"
                  frameborder="0"
                  sandbox="allow-top-navigation allow-forms allow-scripts allow-same-origin allow-popups"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Portfolio;
